export const VOICE_DEVICE_HEIGHT = 777;
export const VOICE_DEVICE_WIDTH = 375;
export const DIALER_CHANNEL_NAME = 'voice_dialer';
export const DIALER_RESTING_CHANNEL_NAME = 'voice_dialer_resting';
export const VOICE_CHANNEL_NAME = 'voice';
export const CLEAN_PHONE_NUMBER_REGEX = /[()-\s]/g;

export const CALL_QUEUE_TRACKING_PROPERTIES = { button_label: 'call queue' };
export const CALL_QUEUE_ANSWER_BUTTON_NAME = 'answer';
export const CALL_QUEUE_DECLINE_BUTTON_NAME = 'decline';
